<section
  class="summary-card"
  [class.panel]="variant() === 'panel'"
  [attr.aria-label]="variant() === 'panel' ? 'Resumen de simulación' : null"
  [attr.aria-labelledby]="variant() === 'panel' ? null : 'simulation-summary-title'"
>
  @if (variant() === 'card') {
    <h2 id="simulation-summary-title" class="heading">Resumen de simulación</h2>
  }

  <div class="steps">
    @for (step of steps; track step.id; let stepIndex = $index) {
      <section
        class="step"
        [class.step-completed]="step.status === 'completed'"
        [class.step-current]="step.status === 'current'"
        [attr.aria-label]="
          step.status === 'current'
            ? 'Paso actual: ' + step.title
            : 'Paso completado: ' + step.title
        "
      >
        <div class="step-header">
          @if (step.status === 'current') {
            <span class="step-marker" aria-hidden="true"></span>
          } @else {
            <span class="step-check" aria-hidden="true"></span>
          }
          <h3 class="step-title">{{ stepIndex + 1 }}. {{ step.title }}</h3>
          @if (step.status === 'current') {
            <span class="current-badge">Paso actual</span>
          } @else {
            <app-button
              [ariaLabel]="'Editar ' + step.title"
              [innerId]="'summary-edit-' + step.id"
              label="Editar"
              styleClass="tertiary negative"
            />
          }
        </div>

        @if (step.answers.length > 0) {
          <ul class="answers">
            @for (answer of step.answers; track answer.questionId) {
              <li class="answer">
                <p class="question">{{ answer.questionLabel }}</p>
                <p class="value">{{ answer.displayValue }}</p>
              </li>
            }
          </ul>
        }
      </section>
    }
  </div>
</section>
